import React from 'react';
import './Competition.css';
import '../Button/Button';
import Button from '../Button/Button';
import { useTranslation } from 'react-i18next';

const Competition = ({ isMenuOpen }) => {
  const { t } = useTranslation();

  return (
    <div className={isMenuOpen ? 'comp-menu-open' : 'competition-container'}>
      <div className="competition-header">
        <h3>{t('competitionGuideHeading')}</h3>
        <a
          href="/documents/Guia Competidor LWDC.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button className="comp-button">{t('guideButton')}
          </Button>
        </a>
                <a
          href="/documents/informativos.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button className="info-button">{t('infoButton')}
          </Button>
        </a>
      </div>
      <div className="danceplace-data-container">
        <iframe
          src="https://www.danceplace.com/dorg/embed/lwdc"
          title="Danceplace LWDC Data"
          style={{ width: '100%', height: '100%', border: 'none' }}
        ></iframe>
      </div>
    </div>
  );
};

export default Competition;
